import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {TextInputField} from '@/components/molecules';
import {TextArea, TargetTypeLabel} from '@/components/atoms';
import {
  STRING_SCHEMA,
  PRE_REQ_FIELD_CONFIG as FIELD_CONFIG
} from '@/services/schema/displayContentSchema';

export const DisplayPreReqContentTab = ({formData, setFormData, languages}) => {
  const handleFieldChange = useCallback(
    (langCode, fieldName, value, hasError) => {
      setFormData({
        ...formData,
        [langCode]: {
          ...formData?.[langCode],
          [fieldName]: value,
          [`${fieldName}Valid`]: hasError
        }
      });
    },
    [formData, setFormData]
  );

  return (
    <div className='grid grid-cols-2'>
      {languages?.map((lang) => {
        const langData = formData?.[lang.code] || {};
        return (
          <div
            key={lang.code}
            className='col-span-1 w-full max-w-full overflow-hidden p-2'>
            <h3 className='mb-4 text-lg font-semibold text-white'>
              {lang.title}
            </h3>
            <div className='display-content-form'>
              <TargetTypeLabel value={langData?.targetType} />

              <div className='grid gap-y-4'>
                <TextInputField
                  value={langData?.title || ''}
                  label={FIELD_CONFIG.title.label}
                  updateValue={(val, hasError) =>
                    handleFieldChange(lang.code, 'title', val, hasError)
                  }
                  schema={STRING_SCHEMA}
                  uiSchema={FIELD_CONFIG.title}
                  required
                  visible
                />
                <TextInputField
                  value={langData?.category || ''}
                  label={FIELD_CONFIG.category.label}
                  updateValue={(val, hasError) =>
                    handleFieldChange(lang.code, 'category', val, hasError)
                  }
                  schema={STRING_SCHEMA}
                  uiSchema={FIELD_CONFIG.category}
                  required
                  visible
                />
              </div>

              <div className='display-content-textarea grid gap-y-4'>
                <TextInputField
                  value={langData?.excerpt || ''}
                  label={FIELD_CONFIG.excerpt.label}
                  updateValue={(val, hasError) =>
                    handleFieldChange(lang.code, 'excerpt', val, hasError)
                  }
                  schema={STRING_SCHEMA}
                  uiSchema={FIELD_CONFIG.excerpt}
                  required
                  visible
                />
                <TextArea
                  value={langData?.terms || ''}
                  label={FIELD_CONFIG.terms.label}
                  updateValue={(val, hasError) =>
                    handleFieldChange(lang.code, 'terms', val, hasError)
                  }
                  uiSchema={FIELD_CONFIG.terms}
                  trim={false}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

DisplayPreReqContentTab.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  languages: PropTypes.array.isRequired
};
